import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useQueryParams } from '../../hooks/useQueryParams';
import { base64Decode } from '../../utils';
import { Button, CircularProgress, Backdrop } from '@mui/material';

const ScormView = () => {
    const scormManagerRef = useRef(null);

    const history = useHistory();

    const params = useQueryParams();

    const [open, setOpen] = useState(true);

    const encodedCourseId = params.get('encodedCourseId');
    const encodedSubjectId = params.get('encodedSubjectId');
    const decodedScormUrl = base64Decode(params.get('encodedUrl'));

    const returnToCourse = (e) => {
        destroyScormIframe();

        history.push(
            `/curso/${encodedCourseId}?id=${encodedSubjectId}&origin=`
        );
    };

    setTimeout(() => setOpen(false), 5000);

    const destroyScormIframe = async () => {
        const scormCloudIframe = scormManagerRef?.current?.contentWindow;
        scormCloudIframe.close();
        scormCloudIframe.location.href = 'about:blank';
    };

    return (
        <ScormManagerContainer>
            <ScormManagerIframe ref={scormManagerRef} src={decodedScormUrl} />
            <ReturnButton onClick={returnToCourse}>
                Volver al cursado
            </ReturnButton>
            <Backdrop open={open}>
                <CircularProgress />
            </Backdrop>
        </ScormManagerContainer>
    );
};

export default ScormView;

const ScormManagerContainer = styled.div`
    position: relative;
    height: 100dvh;
    width: 100dvw;

    display: grid;
    place-items: center;
    text-align: center;
    z-index: 10;
`;

const ScormManagerIframe = styled.iframe`
    height: 100%;
    width: 100%;
    border: none;
`;

const ReturnButton = styled(Button)`
    position: absolute;
    margin: 0;
    right: 2rem;
    bottom: 2rem;
`;

const SpinnerWrapper = styled.div`
    position: absolute;
    height: 100% !important;
    margin: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1 !important;
`;

const Spinner = styled(CircularProgress)``;
